import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { Button, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Skeleton } from '@material-ui/lab';
import CustomIcon from 'commons/Icon/CustomIcon';
import LocalizedText from 'commons/LocalizedText/LocalizedText';
import React from 'react';
import NoteDisplay from './NoteDisplay';

const useStyles = makeStyles((theme) => ({
  addNoteButtonGrid: {
    backgroundColor: theme.palette.primary.main,
    padding: '5px 15px',
    minWidth: '130px',
    color: 'white',
    borderRadius: '20px'
  }
}));

const NoteList = ({notes, isLoadingNote, handleDeleteNote, handleEditNote, handleCreateNote, getUnreadNotesNumber}) => {
  const classes = useStyles();

  return (
    <>
      <Grid item style={{alignSelf: "center"}}>
        <Button
          onClick={handleCreateNote}
        >
          <Grid alignContent="center" className={classes.addNoteButtonGrid} container justifyContent="space-between" spacing={1}>
            <Grid item>
              <CustomIcon icon={faPlus} />
            </Grid>
            <Grid item>
              <LocalizedText>newNote</LocalizedText>
            </Grid>
          </Grid>
        </Button>
      </Grid>
      <Grid item>
        {isLoadingNote ?
          <Grid alignContent="center" container direction="column" spacing={1}>
            <Grid item><Skeleton style={{height:'130px', width:'570px'}} variant="rect" /></Grid>
            <Grid item><Skeleton style={{height:'130px', width:'570px'}} variant="rect" /></Grid>
          </Grid>
          :
          <Grid alignContent="center" container direction="column" >
            {notes.map(note => (
              <div key={note.id}>
                <NoteDisplay
                  getUnreadNotesNumber={getUnreadNotesNumber}
                  handleDeleteNote={handleDeleteNote}
                  handleEditNote={handleEditNote}
                  noteData={note}
                />
              </div>
            ))}
          </Grid>}
      </Grid>
    </>
  );
};

export default NoteList;